const dashboardsConfig = {
  gridStep: 15,
}
export default dashboardsConfig
